import { Box, Grid, Paper } from "@mui/material";
import React from "react";
import EmbedInstructions from "./EmbedInstructions";

const Ui: React.FC = () => {
  return (
    <>
      <Box p={2}>
        <Paper elevation={3} style={{ borderRadius: 3, border: "1px solid #444" , height: "100%" }}>
          <EmbedInstructions />
        </Paper>
      </Box>
    </>
  );
};

export default Ui;
